import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from '../../Button/Button';

const Controls = ({
  actionClassName,
  children,
  controlClassName,
  disabled,
  expanded,
  extraAction,
  id,
  onKeyDown,
  toggle,
  triggerClassName,
  triggerRef,
  buttonClassName,
}) => {
  const actionClasses = cn('c-accordion__action', actionClassName);
  const controlClasses = cn('c-accordion__controls', controlClassName);
  const triggerClasses = cn(
    'c-accordion__trigger',
    {
      'is-disabled': disabled,
      'is-open': expanded,
    },
    triggerClassName
  );

  const action = extraAction && (
    <div className={actionClasses}>{extraAction}</div>
  );

  const icon = expanded ? 'arrow-down' : 'arrow-right';

  return (
    <div className={controlClasses}>
      <Button
        aria-controls={`${id}-panel`}
        // aria-selected={expanded}
        buttonRef={triggerRef}
        className={triggerClasses}
        color="none"
        disabled={disabled}
        icon={icon}
        id={`${id}-trigger`}
        data-testid={`${id}-trigger`}
        onKeyDown={onKeyDown}
        onClick={toggle}
        buttonClassName={buttonClassName}
        type="button"
      >
        {children}
      </Button>
      {action}
    </div>
  );
};

export default Controls;

Controls.propTypes = {
  actionClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  controlClassName: PropTypes.string,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  extraAction: PropTypes.node,
  id: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  triggerClassName: PropTypes.string,
  triggerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
    .isRequired,
  buttonClassName: PropTypes.string,
};

Controls.defaultProps = {
  actionClassName: '',
  children: null,
  className: '',
  controlClassName: '',
  disabled: false,
  expanded: false,
  extraAction: null,
  triggerClassName: '',
  buttonClassName: '',
};
